<mat-card style="width: 100%; height: 100%;" class=card>
	<button style="width: 100%; height: 100%;" class="button mat-elevation-z0" (click)="this.clicked()">
		<div class="mat-elevation-z0 fx-layout-column fx-align-center-center">
			<div class="icon-container fx-flex-50">
					<mat-icon fontSet="material-icons-outlined" class=main-icon>{{this.icon}}</mat-icon>
			</div>
			<div class="text fx-flex">
				{{this.text}}
			</div>
		</div>
	</button>
</mat-card>
